import React, { useEffect, useRef, useState } from "react";
import MasterLayout from "../Sections/MasterLayout";
import { Html5Qrcode } from "html5-qrcode";

const CHECKIN_API = "https://rang-rasiya-backend.onrender.com/api/admin_link/check-in";

export default function ScanPass() {
  const [digits, setDigits] = useState("");
  const [result, setResult] = useState(null);
  const [cameraOpen, setCameraOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const scannerRef = useRef(null);

  // 🔢 Auto verify when 4 digits entered
  useEffect(() => {
    if (digits.length === 4) {
      verifyCode(`RR-${digits}`);
    }
  }, [digits]);

  const verifyCode = async (bookingCode) => {
    try {
      setLoading(true);

      const res = await fetch(CHECKIN_API, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ bookingCode }),
      });

      const data = await res.json();
      setResult(data);
      stopScanner();
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  // 📷 START SCANNER (DOM-safe)
  useEffect(() => {
    if (!cameraOpen) return;

    const startScanner = async () => {
      const html5QrCode = new Html5Qrcode("reader");
      scannerRef.current = html5QrCode;

      try {
        await html5QrCode.start(
          { facingMode: "environment" },
          { fps: 10, qrbox: 250 },
          (decodedText) => {
            verifyCode(decodedText);
          },
          (error) => {
            console.log(error);
          }
        );
      } catch (err) {
        console.error("Camera start error:", err);
      }
    };

    // Small delay ensures DOM render
    setTimeout(startScanner, 300);

    return () => {
      stopScanner();
    };
  }, [cameraOpen]);

  // 🛑 STOP SCANNER
  const stopScanner = async () => {
    if (scannerRef.current) {
      try {
        await scannerRef.current.stop();
        await scannerRef.current.clear();
      } catch (err) {}
      scannerRef.current = null;
    }
    setCameraOpen(false);
  };

  const reset = () => {
    setDigits("");
    setResult(null);
    setCameraOpen(false);
  };

  return (
    <MasterLayout>
      <div className="bg-white p-8 rounded-xl shadow max-w-lg mx-auto">

        <div className="flex justify-between items-center mb-6">
          <h2 className="text-2xl font-bold">Pass Verification</h2>

          <button
            onClick={() => setCameraOpen(true)}
            className="bg-pink-600 text-white px-4 py-2 rounded-lg"
          >
            Scan
          </button>
        </div>

        {/* CAMERA */}
        {cameraOpen && (
          <div className="mb-6">
            <div
              id="reader"
              className="rounded-lg overflow-hidden"
            ></div>

            <button
              onClick={stopScanner}
              className="mt-4 text-sm underline text-red-500"
            >
              Close Camera
            </button>
          </div>
        )}

        {/* MANUAL ENTRY */}
        {!cameraOpen && !result && (
          <div className="text-center">

            <div className="text-3xl font-mono mb-4">
              RR-
              <input
                type="text"
                maxLength={4}
                value={digits}
                onChange={(e) =>
                  setDigits(e.target.value.replace(/\D/g, ""))
                }
                className="w-24 text-center border-b-2 border-pink-500 outline-none text-3xl"
                autoFocus
              />
            </div>

            <p className="text-gray-500 text-sm">
              Enter last 4 digits of booking code
            </p>

            {loading && (
              <p className="mt-4 text-pink-600 font-semibold">
                Verifying...
              </p>
            )}
          </div>
        )}

        {/* RESULT */}
        {result && (
          <div className="mt-6 p-6 rounded-xl text-center bg-gray-100">

            {result.success ? (
              <div className="text-green-600">
                <h3 className="text-xl font-bold mb-2">
                  ✅ Check-in Successful
                </h3>
                <p className="font-semibold">
                  {result.data?.name}
                </p>
                <p className="capitalize">
                  {result.data?.passType} Pass
                </p>
                <p className="font-mono mt-2">
                  {result.data?.bookingCode}
                </p>
              </div>
            ) : (
              <div className="text-red-500 font-bold">
                ❌ {result.message}
              </div>
            )}

            <button
              onClick={reset}
              className="mt-4 text-sm underline"
            >
              Verify Another
            </button>
          </div>
        )}

      </div>
    </MasterLayout>
  );
}